import { useSelector } from 'react-redux'
import { debounce } from 'lodash'
import { useAppDispatch } from '@/state'

import {
  SaveWageringCategoryPayload,
  WageringCategory,
  WageringCategorySaveItem,
} from '@/state/wagering-contribution/models'
import {
  setCurrentWageringCategoryAction,
  setWCCategoryAction,
  wageringSelector,
} from '@/state/wagering-contribution/slices/index.slices'
import { getAllCategoriesThunk } from '@/state/wagering-contribution/thunks/get-all-categories.thunk'

import { getWCCategoriesThunk } from '@/state/wagering-contribution/thunks/get-wc-categories.thunk'
import { saveWCCategoryThunk } from '@/state/wagering-contribution/thunks/save-wc-category.thunk'

export const useWageringActions = () => {
  const { wageringCategory, wageringContributionId } =
    useSelector(wageringSelector)

  const dispatch = useAppDispatch()

  const getAllWageringCategory = debounce(
    () => {
      dispatch(getWCCategoriesThunk())
    },
    500, // eslint-disable-line
  )

  const getAllCategories = debounce(
    () => {
      dispatch(getAllCategoriesThunk({}))
    },
    500, // eslint-disable-line
  )

  const saveWageringCategory = debounce(
    (payload: SaveWageringCategoryPayload) => {
      dispatch(saveWCCategoryThunk({ ...payload }))
    },
    500, // eslint-disable-line
  )

  const deleteWageringCategory = debounce(
    (payload: number | string) => {
      const savedWageringItemsList: WageringCategorySaveItem[] = []
      wageringCategory
        .filter((item: WageringCategory) => item.id !== Number(payload))
        .forEach((wagering: WageringCategory) => {
          const wageringItem: WageringCategorySaveItem = {
            code: wagering.code,
            percentage: wagering.percentage,
            isBlocked: wagering.isBlocked,
            type: wagering.type,
          }
          savedWageringItemsList.push(wageringItem)
        })

      dispatch(
        saveWCCategoryThunk({
          _id: wageringContributionId,
          name: 'Default Wagering Contribution',
          contributions: savedWageringItemsList,
        }),
      )
    },
    500, // eslint-disable-line
  )

  const setCurrentWageringCategory = debounce(
    (payload?: WageringCategory) => {
      dispatch(setCurrentWageringCategoryAction(payload || null))
    },
    500, // eslint-disable-line
  )

  const setWageringCategory = debounce(
    (payload: WageringCategory[]) => {
      dispatch(setWCCategoryAction(payload))
    },
    500, // eslint-disable-line
  )

  return {
    getAllWageringCategory,
    getAllCategories,
    setWageringCategory,
    saveWageringCategory,
    deleteWageringCategory,
    setCurrentWageringCategory,
  }
}
